import { TEDCustomDateTimeDisplayer } from './TEDCustomDateTimeDisplayer';
import { TEDParseDateTimeMode } from '../FormatterTypes';

class TEDDisplayDateTimeGeneral extends TEDCustomDateTimeDisplayer {
  public static getInstance(): TEDDisplayDateTimeGeneral {
    return this.instance ? this.instance : (this.instance = new this());
  }

  private static instance: TEDDisplayDateTimeGeneral;
  mode(): TEDParseDateTimeMode {
    return TEDParseDateTimeMode.pdmGeneral;
  }
}

export { TEDDisplayDateTimeGeneral };
